import { createIconComponent } from '../../factory/create-icon-component';
export const TaiwanIcon = createIconComponent(
  'TaiwanIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33710)">
      <path d="M23 5H1V20H23V5Z" fill="#D80027" />
      <path d="M12 5H1V12.5H12V5Z" fill="#0052B4" />
      <path
        d="M9.01095 8.75001L7.98499 9.24357L8.53129 10.2598L7.41724 10.0418L7.27605 11.1929L6.50008 10.3463L5.72406 11.1929L5.58291 10.0418L4.46886 10.2598L5.01516 9.24353L3.9892 8.75001L5.01516 8.25645L4.46886 7.2402L5.58291 7.45817L5.7241 6.30713L6.50008 7.15367L7.27609 6.30713L7.41724 7.45817L8.53134 7.2402L7.98499 8.25645L9.01095 8.75001Z"
        fill="#F0F0F0"
      />
      <path
        d="M6.50026 10.0249C7.1886 10.0249 7.74661 9.45417 7.74661 8.75017C7.74661 8.04617 7.1886 7.47546 6.50026 7.47546C5.81192 7.47546 5.25391 8.04617 5.25391 8.75017C5.25391 9.45417 5.81192 10.0249 6.50026 10.0249Z"
        fill="#0052B4"
      />
      <path
        d="M6.49959 9.60215C6.04017 9.60215 5.66638 9.21982 5.66638 8.74999C5.66638 8.28012 6.04021 7.89783 6.49959 7.89783C6.95901 7.89783 7.3328 8.28016 7.3328 8.74999C7.3328 9.21982 6.95901 9.60215 6.49959 9.60215Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_10086_33710">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
